import { render, staticRenderFns } from "./OeAiTemp.vue?vue&type=template&id=557a89c4&scoped=true&"
import script from "./OeAiTemp.vue?vue&type=script&lang=js&"
export * from "./OeAiTemp.vue?vue&type=script&lang=js&"
import style0 from "./OeAiTemp.vue?vue&type=style&index=0&id=557a89c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557a89c4",
  null
  
)

export default component.exports